export default {
  data() {
    this.layer = null
    this.map = null
    this.latlng = {
      lat: 0,
      lng: 0,
    }
    return {
      model: null,
    }
  },
  destroyed() {
    if (this.destroySubs) {
      this.destroySubs.unsubscribe()
    }
  },
  methods: {
    closeMenu() {
      this.$emitter.emit('leaflet.context', {
        action: 'closeMenu',
      })
    },
    // For exam: openPopup after all click event is ended
    // or use @click.prevent.stop and call context menu close manualy
    execMethodAfterAllEvents(cb) {
      setTimeout(() => {
        cb.call(this)
      }, 0)
    },
    injectConf(
      options = {
        layer: null,
        e: null,
        map: null,
      }
    ) {
      let { layer, e, map } = options

      if (e) {
        this.latlng = e.latlng
      }

      if (layer) {
        this.layer = layer
        this.map = map
        this.model = Object.assign({}, layer.options.model)
        this.registerVueInMap()
      }
    },
    registerVueInMap() {
      this.destroySubs = this.$emitter.listen('geo.destroyMap', () => {
        this.$destroy()
      })
    },
    registerClosePopup() {},
  },
}
